/**
 * Идентификаторы
 */
export const SP_CATEGORY = 'category';

export const SP_JANUARY = 'january';
export const SP_FEBRUARY = 'february';
export const SP_MARCH = 'march';
export const SP_APRIL = 'april';
export const SP_MAY = 'may';
export const SP_JUNE = 'june';
export const SP_JULY = 'july';
export const SP_AUGUST = 'august';
export const SP_SEPTEMBER = 'september';
export const SP_OCTOBER = 'october';
export const SP_NOVEMBER = 'november';
export const SP_DECEMBER = 'december';

export const SP_TOTAL = 'total';

/**
 * Названия колонок
 */
export const GENERAL_PLAN_LABEL = 'ОБЩИЙ ПЛАН';

export const SP_JANUARY_LABEL = 'Январь';
export const SP_FEBRUARY_LABEL = 'Февраль';
export const SP_MARCH_LABEL = 'Март';
export const SP_APRIL_LABEL = 'Апрель';
export const SP_MAY_LABEL = 'Май';
export const SP_JUNE_LABEL = 'Июнь';
export const SP_JULY_LABEL = 'Июль';
export const SP_AUGUST_LABEL = 'Август';
export const SP_SEPTEMBER_LABEL = 'Сентябрь';
export const SP_OCTOBER_LABEL = 'Октябрь';
export const SP_NOVEMBER_LABEL = 'Ноябрь';
export const SP_DECEMBER_LABEL = 'Декабрь';

export const SP_TOTAL_LABEL = 'ИТОГО';

/**
 * Типы колонок
 */
export type SalePlanMonthFrontKey =
  | typeof SP_JANUARY
  | typeof SP_FEBRUARY
  | typeof SP_MARCH
  | typeof SP_APRIL
  | typeof SP_MAY
  | typeof SP_JUNE
  | typeof SP_JULY
  | typeof SP_AUGUST
  | typeof SP_SEPTEMBER
  | typeof SP_OCTOBER
  | typeof SP_NOVEMBER
  | typeof SP_DECEMBER;

export type SalePlanTableColumn = {
  id: SalePlanMonthFrontKey | typeof SP_CATEGORY | typeof SP_TOTAL;
  label: string | JSX.Element;
  serverKey?: string;
  monthJsIndex?: number;
};

/**
 * Сводный объект
 */
export const SP_TABLE_COLUMNS: Array<SalePlanTableColumn> = [
  {
    id: SP_CATEGORY,
    label: '',
  },
  {
    id: SP_JANUARY,
    label: <span data-testid="month-title">{SP_JANUARY_LABEL}</span>,
    serverKey: '1',
    monthJsIndex: 0,
  },
  {
    id: SP_FEBRUARY,
    label: <span data-testid="month-title">{SP_FEBRUARY_LABEL}</span>,
    serverKey: '2',
    monthJsIndex: 1,
  },
  {
    id: SP_MARCH,
    label: <span data-testid="month-title">{SP_MARCH_LABEL}</span>,
    serverKey: '3',
    monthJsIndex: 2,
  },
  {
    id: SP_APRIL,
    label: <span data-testid="month-title">{SP_APRIL_LABEL}</span>,
    serverKey: '4',
    monthJsIndex: 3,
  },
  {
    id: SP_MAY,
    label: <span data-testid="month-title">{SP_MAY_LABEL}</span>,
    serverKey: '5',
    monthJsIndex: 4,
  },
  {
    id: SP_JUNE,
    label: <span data-testid="month-title">{SP_JUNE_LABEL}</span>,
    serverKey: '6',
    monthJsIndex: 5,
  },
  {
    id: SP_JULY,
    label: <span data-testid="month-title">{SP_JULY_LABEL}</span>,
    serverKey: '7',
    monthJsIndex: 6,
  },
  {
    id: SP_AUGUST,
    label: <span data-testid="month-title">{SP_AUGUST_LABEL}</span>,
    serverKey: '8',
    monthJsIndex: 7,
  },
  {
    id: SP_SEPTEMBER,
    label: <span data-testid="month-title">{SP_SEPTEMBER_LABEL}</span>,
    serverKey: '9',
    monthJsIndex: 8,
  },
  {
    id: SP_OCTOBER,
    label: <span data-testid="month-title">{SP_OCTOBER_LABEL}</span>,
    serverKey: '10',
    monthJsIndex: 9,
  },
  {
    id: SP_NOVEMBER,
    label: <span data-testid="month-title">{SP_NOVEMBER_LABEL}</span>,
    serverKey: '11',
    monthJsIndex: 10,
  },
  {
    id: SP_DECEMBER,
    label: <span data-testid="month-title">{SP_DECEMBER_LABEL}</span>,
    serverKey: '12',
    monthJsIndex: 11,
  },
  {
    id: SP_TOTAL,
    label: <span data-testid="total-sum">{SP_TOTAL_LABEL}</span>,
  },
];
